import { Marquee } from "../ui/marquee"

import beyondtrust from "../../assets/logos/editors/beyondtrust.png"
import forscout from "../../assets/logos/editors/forscout.png"
import infoblox from "../../assets/logos/editors/infoblox-rev.png"
import ivanti from "../../assets/logos/editors/ivanti.png"
import sophos from "../../assets/logos/editors/sophos.png"
import trendmicro from "../../assets/logos/editors/trendmicro.png"

export function EditorsSection() {
    const logos = [
        {name: "BeyondTrust", logo: beyondtrust},
        {name: "Forescout", logo: forscout},
        {name: "Infoblox", logo: infoblox},
        {name: "Ivanti", logo: ivanti},
        {name: "Sophos", logo: sophos},
        {name: "Trend Micro", logo: trendmicro},
    ]

    return (
        <section className="py-8 bg-transparent relative overflow-hidden">
            <div className="z-10 absolute left-0 top-0 h-full w-1/6 bg-gradient-to-r from-black to-zinc-900/0"></div>
            <div className="z-10 absolute right-0 top-0 h-full w-1/6 bg-gradient-to-l from-black to-zinc-900/0"></div>

            <Marquee className="flex items-center justify-center" direction="left" speed={50} pauseOnHover={true}>
                {logos.map((logo, index) => (
                    <div
                        key={index}
                        className="mx-12 flex items-center justify-center group transition-transform duration-300 ease-in-out"
                    >
                        <div className="h-16 flex items-center justify-center">
                            <img
                                src={logo.logo || "/placeholder.svg"}
                                alt={logo.name}
                                className="h-12 max-w-[180px] object-contain filter grayscale opacity-60 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100"
                            />
                        </div>
                    </div>
                ))}
            </Marquee>
        </section>
    )
}
